/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotifyNewVersionResultModel } from '../../models/notify-new-version-result-model';

export interface AdminNotifyNewVersionPost$Params {
}

export function adminNotifyNewVersionPost(http: HttpClient, rootUrl: string, params?: AdminNotifyNewVersionPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<NotifyNewVersionResultModel>> {
  const rb = new RequestBuilder(rootUrl, adminNotifyNewVersionPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<NotifyNewVersionResultModel>;
    })
  );
}

adminNotifyNewVersionPost.PATH = '/Admin/NotifyNewVersion';
